import React, { Component } from 'react';
import { Translate } from 'react-localize-redux';
import { Link } from 'react-router-dom';

import GlobalLayout from 'Layouts/Global.layout';

import {
  handleOTPTimerOutput,
  getErrorContent,
  genericComponentTimer
} from 'Utils/Helpers/component.helpers';
import { Container, Card, Text, FormElements, Button } from 'UILib';
import {
  REQUEST_STATUS,
  APP_ROUTES
} from 'Constants/GlobalConstants/Global.constants';

import 'Components/Authentication/authentication.style.scss';

const ENTER_KEY = 13;
class LoginWithMFA extends Component {
  constructor(props) {
    super(props);

    this.state = { otp_code: '', remaining: 60, hasDigitError: false };
  }

  componentDidMount() {
    this.timer = genericComponentTimer(() => {
      this.setState({ remaining: this.state.remaining - 1 });
    });
    document.addEventListener('keydown', (e) => {
      this.handleKeyDown(e);
    });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    document.removeEventListener('keydown', (e) => {
      this.handleKeyDown(e);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    /**
     * Handles error case and toggles hasDigitError
     */
    if (prevProps.login.error === null && this.props.login.error) {
      this.setState({ hasDigitError: true });
    }
    /**
     * Resets otp_code value when a wrong otp code is entered
     */
    if (this.props.login.otp_code_tries !== prevProps.login.otp_code_tries) {
      this.setState({ otp_code: '' });
    }
    /**
     * Concludes mfa login flow with a failure screen when timer reaches 00:00
     */
    if (this.state.remaining === 0) {
      this.props.userLoginWithMFAExpire();
    }
  }

  handleKeyDown = (e) => {
    e.keyCode === ENTER_KEY && this.handleSubmit();
  };

  handleChange = (otp_code) => {
    this.setState({ otp_code });
  };

  handleSubmit = () => {
    const { access_token } = this.props.login;
    const { otp_code } = this.state;

    if (otp_code.length === 6) {
      this.setState({ hasDigitError: false });
      this.props.userLoginWithMFA(access_token, otp_code);
    } else {
      this.setState({ hasDigitError: true });
    }
  };

  render() {
    const definedClientCodes = [400, 401];
    const { minutes, seconds } = handleOTPTimerOutput(this.state.remaining);
    const { otp_code } = this.state;
    const { otp_code_tries } = this.props.login;
    return (
      <Container type="page" bgColor="grey-0">
        <GlobalLayout>
          <Card type="auth" centered>
            <Text
              type="h1"
              content="login.mfa.header"
              translation
              className="generic-authentication-header"
            />
            <Container className="verify-code-otp-container">
              <Container className="descriptive-text">
                <Text
                  type="intro"
                  content="login.mfa.description"
                  className="descriptive-text"
                  translation
                />
                <Text
                  type="h1"
                  content={`${minutes}:${seconds}`}
                  className="timer-text"
                />
              </Container>
              <Container className="digits-container">
                <FormElements.Digit
                  type="number"
                  digits={6}
                  error={this.state.hasDigitError}
                  value={otp_code}
                  onChange={this.handleChange}
                />
                <Text
                  type="intro"
                  content={`${otp_code_tries} / 3`}
                  color="grey-2"
                  className="tries-text"
                />
              </Container>
              <Container className="generic-container">
                {this.props.login.error && (
                  <FormElements.ValidationErrors
                    content={getErrorContent(
                      this.props.login.error,
                      [],
                      '',
                      'login.mfa.failure.errors',
                      definedClientCodes
                    )}
                    translation
                  />
                )}
              </Container>
              <Container className="right-align">
                <Button
                  content={
                    this.props.login.status === REQUEST_STATUS.PENDING
                      ? 'login.mfa.loading_label'
                      : 'login.mfa.submit_label'
                  }
                  color="white"
                  bgColor="orange-3"
                  borderColor="orange-3"
                  translation
                  onClick={() => {
                    this.handleSubmit();
                  }}
                />
              </Container>
            </Container>
            <Text type="intro" className="padded-string">
              <Translate id="login.mfa.footer.content" />{' '}
              <Link to={APP_ROUTES.REGISTER}>
                <Translate id="login.mfa.footer.cta" />
              </Link>
            </Text>
          </Card>
        </GlobalLayout>
      </Container>
    );
  }
}

export default LoginWithMFA;
